<template>
  <div class="sa-matching-page-skeleton" aria-hidden="true">
    <div class="sa-matching-page-skeleton__hero sa-skeleton" />
    <div v-for="index in 3" :key="index" class="sa-matching-page-skeleton__panel sa-skeleton" />
  </div>
</template>
